module.exports = __webpack_public_path__ + "img/ceo_way_tip_05.ab214052.png";